// start:ng42.barrel
import './cca-team-bulk-created-list.directive';
import './team-attendance.directive';
import './team-join-requests.directive';
import './team-member-list.directive';
// end:ng42.barrel

